export enum BillingContractPartnerType {
  BUYER = 'BUYER',
  SELLER = 'SELLER',
  OTHER = 'OTHER',
}
